import React, { Suspense } from 'react';
import { memberId } from '@trello/session-cookie';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';

export const Banners = () => {
  const AtlassianAccountOnboardingBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-onboarding-banner" */ 'app/src/components/AtlassianAccountOnboardingBanner'
      ),
    { namedImport: 'AtlassianAccountOnboardingBanner' },
  );
  const AtlassianManagedAccountBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-onboarding-banner" */ 'app/src/components/AtlassianAccountOnboardingBanner'
      ),
    { namedImport: 'AtlassianManagedAccountBanner' },
  );
  const EmailHygieneBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "email-hygiene-banner" */ 'app/src/components/EmailHygieneWizard'
      ),
    { namedImport: 'EmailHygieneBanner' },
  );
  const AtlassianAccountMigrationBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-migration-banner" */ 'app/src/components/AtlassianAccountMigration'
      ),
    { namedImport: 'AtlassianAccountMigrationBanner' },
  );
  const SomethingsWrongBanner = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "somethings-wrong-banner" */ 'app/src/components/SomethingsWrongBanner'
      ),
    { namedImport: 'SomethingsWrongBanner' },
  );

  // Don't render any of the banners if the user isn't logged in
  if (!memberId) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ComponentWrapper>
        <ChunkLoadErrorBoundary fallback={null}>
          <SomethingsWrongBanner />
        </ChunkLoadErrorBoundary>
        <ChunkLoadErrorBoundary fallback={null}>
          <AtlassianAccountOnboardingBanner />
        </ChunkLoadErrorBoundary>
        <ChunkLoadErrorBoundary fallback={null}>
          <AtlassianManagedAccountBanner />
        </ChunkLoadErrorBoundary>
        <ChunkLoadErrorBoundary fallback={null}>
          <EmailHygieneBanner />
        </ChunkLoadErrorBoundary>
        <ChunkLoadErrorBoundary fallback={null}>
          <AtlassianAccountMigrationBanner />
        </ChunkLoadErrorBoundary>
      </ComponentWrapper>
    </Suspense>
  );
};
